import { render, staticRenderFns } from "./bxwd.vue?vue&type=template&id=f01c90b0"
import script from "./bxwd.vue?vue&type=script&lang=js"
export * from "./bxwd.vue?vue&type=script&lang=js"
import style0 from "./bxwd.vue?vue&type=style&index=0&id=f01c90b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports